
import React from "react";
import { Button } from "@/components/ui/button";
import { Eye, Edit, Trash2 } from "lucide-react";

interface CardActionsProps {
  onEdit: () => void;
  onDelete: () => void;
  onViewDetails: () => void;
  studentName: string;
}

const CardActions: React.FC<CardActionsProps> = ({ 
  onEdit, 
  onDelete, 
  onViewDetails,
  studentName 
}) => {
  return (
    <div className="flex gap-1 w-full">
      <Button 
        variant="outline" 
        size="sm" 
        className="flex-1 h-6 text-xs px-2"
        onClick={(e) => {
          e.stopPropagation();
          onViewDetails();
        }}
        data-action-button
        aria-label={`View details for ${studentName}`}
      >
        <Eye className="h-2.5 w-2.5 mr-1" />
        View
      </Button>
      
      <Button 
        variant="outline" 
        size="sm" 
        className="flex-1 h-6 text-xs px-2"
        onClick={(e) => {
          e.stopPropagation();
          onEdit();
        }}
        data-action-button
        aria-label={`Edit ${studentName}`}
      >
        <Edit className="h-2.5 w-2.5 mr-1" />
        Edit
      </Button>
      
      <Button 
        variant="destructive" 
        size="sm" 
        className="flex-1 h-6 text-xs px-2"
        onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
        data-action-button
        aria-label={`Delete ${studentName}`}
      >
        <Trash2 className="h-2.5 w-2.5 mr-1" />
        Delete
      </Button>
    </div>
  );
};

export default CardActions;
